<template>
	<BaseTable
		:is-loading="isLoading"
		:pagination="pagination"
		:fields="USER_TABLE_FIELDS"
		:items="items"
		:hide-columns="['id']"
		name-route="UserEdit"
		striped
		hover
		fixed
		clickable-rows
		class="table-custom"
		@onPaginationClick="handlePageChange"
		@onRowClick="handleRowClick"
		@onSortClick="handleSortClick"
	>
		<template #no-items-view>
			<div class="empty-table-element">
				<p class="subtitle">
					{{ $t('message.not_found_user_list') }}
				</p>
			</div>
		</template>
		<template #role="{ item }">
			{{ item | capitalize }}
		</template>
		<template #updated_at="{ item }">
			{{ dateFriendly(item) }}
		</template>
		<template #is_active="{ item }">
			<CBadge
				class="badge-status"
				:color="item === USER_STATUS.ACTIVE ? 'success' : 'secondary'"
			>
				{{ item === USER_STATUS.ACTIVE ? $t('message.active') : $t('message.inactive') }}
			</CBadge>
		</template>
	</BaseTable>
</template>

<script>
import { USER_TABLE_FIELDS, USER_STATUS } from '../enums/user';
import { dateFriendly } from '../helpers/date';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'UserListTable',

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		items: {
			type: Array,
			default: () => [],
		},
		fields: {
			type: Array,
			default: () => [],
		},
		pagination: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			USER_TABLE_FIELDS,
			USER_STATUS,
			dateFriendly,
		};
	},

	methods: {
		handleRowClick(id) {
			this.$router.push({ name: ROUTER_NAME.USER_EDIT, params: { id } });
		},
		handlePageChange(pageNum) {
			return pageNum;
		},
		handleSortClick(key, state) {
			return state;
		},
	},
};
</script>
